'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitLiveBid = exports.getBidSource = exports.getBidderHasHighBid = exports.getUiLiveBid = exports.LIVE_BID_SUCCESS = exports.LIVE_BID_REQUEST = exports.LIVE_BID_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _pubnubService = require('../../services/pubnubService');

var pubnubService = _interopRequireWildcard(_pubnubService);

var _console = require('./console');

var _reselect = require('reselect');

var _user = require('./user');

var _liveCatalogStatus = require('./liveCatalogStatus');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LIVE_BID_FAIL = exports.LIVE_BID_FAIL = 'la/ui/liveBid/FAIL';
var LIVE_BID_REQUEST = exports.LIVE_BID_REQUEST = 'la/ui/liveBid/REQUEST';
var LIVE_BID_SUCCESS = exports.LIVE_BID_SUCCESS = 'la/ui/liveBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidderHasHighBid: false,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LIVE_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                submitted: true,
                success: false
            });
        case _console.BID_ACCEPTED:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: action.payload.myBid,
                submitted: false,
                success: true
            });
        case _console.LOT_CLOSED:
        case _console.LOT_PASSED:
        case _console.LOT_SKIPPED:
        case _console.LOT_SOLD:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: false,
                submitted: false,
                success: true
            });
        case LIVE_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        case _console.NEXT_LOT_LOADED:
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: false,
                submitted: false
            });
        case _liveCatalogStatus.LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            var currentHighBidderId = action.payload.currentItem.leadingBidder;
            return (0, _extends3.default)({}, state, {
                bidderHasHighBid: action.meta.bidderId === currentHighBidderId
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.liveBid;
};
var getUiLiveBid = exports.getUiLiveBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getBidderHasHighBid = exports.getBidderHasHighBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.bidderHasHighBid;
});

var getBidSource = exports.getBidSource = (0, _reselect.createSelector)(function (state) {
    return state.ui.browser;
}, function (state) {
    return state.mobile ? 'MobileWeb' : 'DesktopWeb';
});

/* ACTIONS CREATORS */
var submitLiveBid = exports.submitLiveBid = function submitLiveBid(actionTime, catalogId, currentAskPrice, currency, itemId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, created, BidderId, BidSource;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            created = new Date(actionTime).toISOString();
                            BidderId = (0, _user.getBidderId)(state);
                            BidSource = getBidSource(state);


                            dispatch({
                                payload: {
                                    amount: currentAskPrice,
                                    catalogId: catalogId,
                                    created: created,
                                    currency: currency
                                },
                                type: LIVE_BID_REQUEST
                            });

                            _context.next = 8;
                            return pubnubService.publish('catalog.' + catalogId + '.' + itemId, {
                                Amount: currentAskPrice,
                                AuctionId: catalogId,
                                BidderId: BidderId,
                                BidSource: BidSource,
                                Created: created,
                                EventType: 'bid-placed',
                                LotId: itemId
                            });

                        case 8:
                            return _context.abrupt('return', dispatch({
                                payload: {
                                    actionTime: actionTime,
                                    amount: currentAskPrice,
                                    catalogId: catalogId,
                                    created: created,
                                    currency: currency
                                },
                                type: LIVE_BID_SUCCESS
                            }));

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LIVE_BID_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/liveBid.js
// module id = xmqD
// module chunks = 60